import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Box } from 'fw/components';
import CustomDialog from './CustomDialog'
import * as Modals from 'fw/globals/Modals'
import * as Notifications from 'fw/globals/Notifications'

class ModalsDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			customDialog: false
		};
	}

	alert = () => {
		Modals.alert("This an alert. Put whatever text you want here.<br />You can use <strong>HTML</strong> if you want to.", function () {
			Notifications.success("Your alert was closed.");
		});
	}

	confirm = () => {
		Modals.confirm("Is today a sunny day?", function () {
			Notifications.success("Great, let's play some soccer!");
		}, function () {
			Notifications.error("Darn, no soccer today!");
		});
	}

    remove = () => {
		Modals.remove({
            title: "Deleting user",
            elementType: "user",
			name: "Marlon Brandon",
			id: 1,
            onYes: (id) => {
                Notifications.success("User with ID = " + id + " has been deleted!");
			},
			onNo: () => {
				Notifications.error("You chicken!");
			}
        });
	}

	inline = () => {
		Modals.inline(
			<div>
				<h1 className="page-header">This is an inline modal demo.</h1>
				<p>
					This is your <i>inline</i> content.<br />
				</p>
			</div>,
			function () {
				Notifications.error("Inline modal dismissed.");
			});
	}

	dialog = () => {
		this.setState({
			customDialog: true
		});
	}

	onDialogClose = () => {
		Notifications.success("Dialog has been closed.");
	}

	render() {
		return (
			<React.Fragment>
				<CustomDialog visible={this.state.customDialog} onClose={this.onDialogClose} />
				<Box title="Generic modals">
					<Row>
						<Col md={12}>
							<Button bsStyle="primary" onClick={this.alert}>Alert</Button>
							<Button bsStyle="warning" onClick={this.confirm}>Confirm</Button>
							<Button bsStyle="danger" onClick={this.remove}>Remove</Button>
							<Button bsStyle="default" onClick={this.inline}>Inline</Button>
							<Button bsStyle="default" onClick={this.dialog}>Dialog</Button>
						</Col>
					</Row>
				</Box>
			</React.Fragment>)
	}
}

export default ModalsDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/Modals/ModalsDemo.js